<template>
  <div class="nav-box">
    <ul>
      <li v-for="(item, index) in navList" :key="index" :class="[tabPage === index ? 'active':'']" @click="handleTabPage(index)">{{ item }}</li>
    </ul>
    <el-divider v-if="showDivider" class="divider"></el-divider>
  </div>
</template>

<script>
export default {
  name: 'NavTab',
  props: ['navList', 'tabPage', 'showDivider'],
  data () {
    return {
    }
  },
  methods: {
    // 菜单切换
    handleTabPage (index) {
      this.$emit('handleTabPage', index)
    }
  }
}
</script>

<style lang="scss">
.nav-box {
  height: 65px;
  z-index: 1;
  position: relative;
  .divider {
    position: absolute;
    bottom: -13px;
    height: 1px;
    width: 1279px;
    margin-left: -40px;
    background-color: #8FA8BC;
  }
  ul {
    display: flex;
    position: absolute;
    width: 808px;
    z-index: 99;
    li {
      position: relative;
      padding: 10px 15px;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 29px;
      color: #424855;
      transition: 0.2s all linear;
      cursor: pointer;
      &::before {
        content: "";
        position: absolute;
        top: 0;
        left: 100%;
        width: 0;
        height: 100%;
        border-bottom: 4px solid #9B232A;
        transition: 0.2s all linear;
        opacity: 0.5;
      }
      &:hover::before {
        width: 100%;
        top: 0;
        left: 0;
        transition-delay: 0.1s;
        border-bottom-color: #9B232A;
        z-index: -1;
        opacity: 0.5;
        transform: scaleX(0.3);
      }
      &:hover ~ li::before {
        left: 0;
      }
      &:active {
        background: #9B232A;
        color: #fff;
      }
      &.active {
        color: #9B232A;
        font-weight: bold;
        font-size: 20px;
        &::after {
          content: "";
          position: absolute;
          top: 0;
          left: 0;
          width: 100%;
          height: 100%;
          border-bottom: 4px solid #9B232A;
          transform: scaleX(0.3);
        }
      }
    }
  }
}
</style>
